import { isWithinFinaliseCallHours } from './finaliseBusinessHours';

export const FINALISE_PAGE_PATH = '/eligibility/offer/finalise';

export type FinaliseAdvisorState = 'in_hours' | 'out_of_hours';

export const getFinaliseDevice = () =>
    window.innerWidth >= 1024 ? 'desktop' : 'mobile';

export const getFinaliseAdvisorState = (
    isInHoursCallFlowEnabled: boolean,
): FinaliseAdvisorState =>
    isInHoursCallFlowEnabled && isWithinFinaliseCallHours()
        ? 'in_hours'
        : 'out_of_hours';

interface FinaliseTrackingPropertiesInput {
    advisorState: FinaliseAdvisorState;
    applicationId: string;
}

export const getFinaliseTrackingProperties = ({
    advisorState,
    applicationId,
}: FinaliseTrackingPropertiesInput) => ({
    advisor_state: advisorState,
    device: getFinaliseDevice(),
    applicationId,
});
